import { AppState } from '..';
import { FETCH_USERS_SUCCESS, SET_USERS_FIELD, RESET_USERS } from '../actions/usersActions'
import { IUserPagination } from '../models/Users';
import { BillsbyAdminAction } from '../models/BillsbyAdminAction';


export interface IUsersReducerState {
  usersPaginated: IUserPagination;
  searchedUsers: string;
  hasUsers: boolean;
}

const initState = {
  usersPaginated: {
    currentPage: 1,
    pageCount: 1,
    pageSize: 0,
    rowCount: 0,
    results: undefined
  },
  searchedUsers: '',
  hasUsers: false
};

export default function usersReducer(
  state: IUsersReducerState = initState,
  action: BillsbyAdminAction,
  store: AppState
) {
  switch (action.type) {
    case SET_USERS_FIELD:
      return { ...state, [action.fieldName]: action.fieldValue };
    case FETCH_USERS_SUCCESS:
      const hasUsers = (!!action.response.results && action.response.results.length > 0) || state.hasUsers;
      return { ...state, usersPaginated: action.response, hasUsers };

    case RESET_USERS:
      return { ...initState };
    default:
      return state;
  }
}
